/**
 * Meta ad click id, so a DNA kit purchase can be attributed to the ad that led to it.
 *
 * Meta appends `fbclid` to ad landing URLs. It is held in memory only — never in a
 * cookie or browser storage — and leaves the page solely as part of a checkout request
 * the visitor starts. The backend forwards it with the server-side Purchase event
 * (backend/services/meta_conversions_service.py), which works without the browser pixel.
 */
const FBCLID_PATTERN = /^[A-Za-z0-9_-]{1,400}$/;

let fbclid: string | undefined;
let clickedAt = 0;

/** Record the click id from a URL query string; later calls without one keep the first. */
export function captureMetaClickId(
  search: string = window.location.search,
  now: number = Date.now()
): void {
  const candidate = new URLSearchParams(search).get('fbclid');
  if (!candidate || !FBCLID_PATTERN.test(candidate) || candidate === fbclid)
    return;
  fbclid = candidate;
  clickedAt = now;
}

/** `fb.1.<click time ms>.<fbclid>`, or undefined when the visitor did not come from a Meta ad. */
export function getMetaFbc(): string | undefined {
  return fbclid ? `fb.1.${clickedAt}.${fbclid}` : undefined;
}

/** Test-only. */
export function resetMetaClickIdForTests(): void {
  fbclid = undefined;
  clickedAt = 0;
}
